function splitAndPrepareText(selector) {
  const splitInstance = new SplitType(selector, {
    types: "lines",
    lineClass: "split-line",
  });

  splitInstance.lines.forEach((line) => {
    const child = document.createElement("span");
    child.classList.add("split-child");
    child.innerHTML = line.innerHTML;
    line.innerHTML = "";
    line.appendChild(child);
  });

  return splitInstance;
}

function animateSplitText(selector, delay = 0) {
  gsap.fromTo(
    `${selector} .split-child`,
    { yPercent: 100 },
    {
      duration: 1.5,
      yPercent: 0,
      ease: "power4",
      stagger: 0.1,
    }
  );
}

window.onload = () => {
  Promise.all([
    document.fonts.ready,
    new Promise((res) => window.requestAnimationFrame(res)),
  ]).then(() => {
    const heroSection = document.querySelector(".image-banner-wrapper");
    let hasAnimated = false;

    const textSplit = splitAndPrepareText(".banner__text");

    const headingSplit = new SplitType(
      ".banner__heading_left .split-line, .banner__heading_right .split-line",
      { types: "lines", lineClass: "split-line" }
    );

    headingSplit.lines.forEach((line) => {
      const child = document.createElement("span");
      child.classList.add("split-child");
      child.innerHTML = line.innerHTML;
      line.innerHTML = "";
      line.appendChild(child);
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            document.querySelector(".banner__box").style.opacity = "1";

            gsap.fromTo(
              ".banner__heading_left .split-line .split-child, .banner__heading_right .split-line .split-child",
              { yPercent: 100 },
              {
                duration: 1.5,
                yPercent: 0,
                ease: "power4",
                stagger: 0.1,
              }
            );

            animateSplitText(".banner__text");

            gsap.fromTo(
              ".banner__buttons",
              { opacity: 0, y: 20 },
              {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: "power2.out",
                delay: 0.5,
              }
            );

            hasAnimated = true;
          }
        });
      },
      { threshold: 0.5 }
    );

    if (heroSection) observer.observe(heroSection);

    // Treat-Prevent Section Animation

    const section = document.querySelector(".treat-prevent");

    const options = {
      rootMargin: "0px",
      threshold: 0.5,
    };

    let willAnimate = 1;

    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && willAnimate == 1) {
          document.querySelector(".treat-prevent__text").style.opacity = "1";
          document.querySelector(".treat-prevent__list").style.opacity = "1";
          gsap.fromTo(
            ".animate-text",
            { yPercent: 100 },
            {
              duration: 1.0,
              opacity: 1,
              yPercent: 0,
              ease: "power4",
              stagger: 0.1,
            }
          );

          const treatItems = document.querySelectorAll(".treat-prevent__item");

          treatItems.forEach((item) => {
            item.classList.add("animate__animated", "animate__fadeInUp");
            item.style.opacity = "1";
            item.style.visibility = "visible";
          });

          willAnimate = 0;
        }
      });
    };

    const observerTreat = new IntersectionObserver(callback, options);
    if (section) {
      observerTreat.observe(section);
    }

    // Visit-Us Section Animation
    const visitSections = document.querySelectorAll(
      ".visit-us-wrapper, .visit-us-wrapper-mobile"
    );

    const optionsVisit = {
      rootMargin: "0px",
      threshold: 0.5,
    };

    let willAnimateVisit = 1;

    const callbackVisit = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && willAnimateVisit == 1) {
          document.querySelector(".visit-us__heading").style.opacity = "1";

          gsap.fromTo(
            ".animate-visit",
            { opacity: 0, yPercent: 100, visibility: "visible" },
            {
              duration: 1.0,
              opacity: 1,
              yPercent: 0,
              ease: "power4",
              stagger: 0.1,
            }
          );

          const visitImages = document.querySelectorAll(".visit-us-img img");
          visitImages.forEach((img) => {
            img.classList.add("animate__animated", "animate__fadeIn");
            img.style.opacity = "1";
            img.style.visibility = "visible";
          });

          willAnimateVisit = 0;
        }
      });
    };

    const observerVisit = new IntersectionObserver(callbackVisit, optionsVisit);
    visitSections.forEach((section) => observerVisit.observe(section));

    const breastLiftSection = document.querySelector(".breast-lift-section");
    if (breastLiftSection) {
      let hasBreastAnimated = false;

      const observerBreast = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !hasBreastAnimated) {
              document.querySelector(".animate-breast-text").style.opacity =
                "1";
              document.querySelector(".wanted-text").style.opacity = "1";

              const breastSplit = splitAndPrepareText(".animate-breast-text");
              document.querySelectorAll(".smaller-text").forEach((el) => {
                el.style.marginLeft = "18px";
              });
              document.querySelectorAll(".wanted-text").forEach((el) => {
                el.style.display = "flex";
              });
              const alignWrapperLine = document
                .querySelector(".align-wrapper")
                ?.closest(".split-line");

              if (alignWrapperLine) {
                alignWrapperLine.classList.add("align-right");
                alignWrapperLine.style.textAlign = "right";
              }

              gsap.fromTo(
                ".animate-breast-text .split-child",
                { yPercent: 100 },
                {
                  duration: 1.5,
                  yPercent: 0,
                  ease: "power4",
                  stagger: 0.1,
                }
              );

              const aboutImages = document.querySelectorAll(
                ".breast-lift-image img"
              );
              aboutImages.forEach((img) => {
                img.classList.add("animate__animated", "animate__fadeInUp");
                img.style.opacity = "1";
                img.style.visibility = "visible";
              });

              hasBreastAnimated = true;
            }
          });
        },
        {
          threshold: 0.2,
        }
      );

      observerBreast.observe(breastLiftSection);
    }

    const pledgeSection = document.querySelector(".pledge-section-wrapper");
    if (pledgeSection) {
      let hasPledgeAnimated = false;

      const observerPledge = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !hasPledgeAnimated) {
              document.querySelector(".animate-pledge-text").style.opacity =
                "1";

              splitAndPrepareText(".animate-pledge-text");
              gsap.fromTo(
                ".animate-pledge-text .split-child",
                { yPercent: 100 },
                {
                  duration: 1.5,
                  yPercent: 0,
                  ease: "power4",
                  stagger: 0.1,
                }
              );

              const pledgeItems =
                document.querySelectorAll(".key-point-wrapper");

              pledgeItems.forEach((item) => {
                item.classList.add("animate__animated", "animate__fadeInUp");
                item.style.opacity = "1";
                item.style.visibility = "visible";
              });

              const pledgeImage = document.querySelectorAll(".pledge-image");
              pledgeImage.forEach((img) => {
                img.classList.add("animate__animated", "animate__fadeInUp");
                img.style.opacity = "1";
                img.style.visibility = "visible";
              });

              hasPledgeAnimated = true;
            }
          });
        },
        { threshold: 0.5 }
      );

      observerPledge.observe(pledgeSection);
    }

    const meetOurTeamSection = document.querySelector(".meet-our-team-section");
    if (meetOurTeamSection) {
      let hasTeamAnimated = false;

      const observerTeam = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !hasTeamAnimated) {
              const title = document.querySelector(".meet-our-team-title");
              document.querySelector(".meet-our-team-title").style.opacity =
                "1";
              if (title) {
                splitAndPrepareText(".meet-our-team-title");

                gsap.fromTo(
                  ".meet-our-team-title .split-child",
                  { yPercent: 100 },
                  {
                    duration: 1.5,
                    yPercent: 0,
                    ease: "power4",
                    stagger: 0.1,
                  }
                );
              }

              hasTeamAnimated = true;
            }
          });
        },
        {
          threshold: 0.5,
        }
      );

      observerTeam.observe(meetOurTeamSection);
    }
  });
};
